import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Typography,
  Grid,
  SvgIcon,
  Paper,
  Divider
} from "@material-ui/core";
import * as React from "react";
import ButtonComponent from "../components/ButtonComponent";
import { AppContext, AuthConsumer } from "../routes/AuthContext";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3
    },
    extendedIcon: {
      marginRight: theme.spacing(1)
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary
    },
    control: {
      padding: theme.spacing(1) * 2
    }
  });
function LockIcon(props: any) {
  return (
    <SvgIcon viewBox="0 0 486.733 486.733" {...props}>
      <g>
        <path
          d="M403.88,196.563h-9.484v-44.388c0-82.099-65.151-150.681-146.582-152.145c-2.225-0.04-6.671-0.04-8.895,0
		C157.486,1.494,92.336,70.076,92.336,152.175v44.388h-9.485c-14.616,0-26.538,15.082-26.538,33.709v222.632
		c0,18.606,11.922,33.829,26.539,33.829h321.028c14.616,0,26.539-15.223,26.539-33.829V230.272
		C430.419,211.646,418.497,196.563,403.88,196.563z M273.442,341.362v67.271c0,7.703-6.449,14.222-14.158,14.222H227.45
		c-7.71,0-14.159-6.519-14.159-14.222v-67.271c-7.477-7.36-11.83-17.537-11.83-28.795c0-21.334,16.491-39.666,37.459-40.513
		c2.222-0.09,6.673-0.09,8.895,0c20.968,0.847,37.459,19.179,37.459,40.513C285.272,323.825,280.919,334.002,273.442,341.362z
		 M331.886,196.563h-84.072h-8.895h-84.072v-44.388c0-48.905,39.744-89.342,88.519-89.342c48.775,0,88.521,40.437,88.521,89.342
		V196.563z"
        />
      </g>
    </SvgIcon>
  );
}
interface Props extends WithStyles<typeof styles> {
  profileData: any;
}
class UnauthorisedScreen extends React.Component<Props> {
  state = { profile: { fullName: "" } };
  componentDidMount = () => {
    let contextState = this.context;
    let user = contextState && contextState.user ? contextState.user : null;
    if (user) {
      this.setState({
        profile: user
      });
    }
  };
  render() {
    return (
      <React.Fragment>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{
            minHeight: "100vh",
            width: "100%",
            alignItems: "center",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Paper
            elevation={3}
            style={{
              width: "50%",
              height: 300,
              margin: 10,
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                flex: 0.3,
                margin: 10,
                backgroundColor: "orange",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <LockIcon style={{ width: 120, height: 120, color: "white" }} />
            </div>
            <div
              style={{
                flex: 0.7,
                padding: 10,
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Typography variant="h4" gutterBottom>
                Whoops!
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                You are authenticated successfully, but you are not authorised
                for this content.
              </Typography>
              <Typography variant="body1" gutterBottom>
                Please contact your Administrator.
              </Typography>
              <div>
                <Typography variant="button" display="block" gutterBottom>
                  You are signed in as:
                </Typography>
                <Typography variant="overline" display="block" gutterBottom>
                  {this.props.profileData && this.props.profileData.fullName
                    ? this.props.profileData.fullName
                    : this.state.profile && this.state.profile.fullName
                      ? this.state.profile.fullName
                      : "NO AVAILABLE"}
                </Typography>
              </div>
              <Divider />
              <AuthConsumer>
                {({ logout }) => (
                  <div
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      height: "100%"
                    }}
                  >
                    <ButtonComponent
                      type="submit"
                      text={"LOGOUT"}
                      onClick={logout}
                    />
                  </div>
                )}
              </AuthConsumer>
            </div>
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }
}
UnauthorisedScreen.contextType = AppContext;
export default withStyles(styles)(UnauthorisedScreen);
